import React, { useState, useLayoutEffect } from "react"
import { useDispatch } from "react-redux"
import { useLocation, useHistory } from "react-router-dom"
import isJWT from "validator/lib/isJWT"
import { parse } from "query-string"
import { toast } from "react-toastify"
import jwtDecode from "jwt-decode"
import { useTranslation } from "react-i18next"

import {
  userLogout,
  getSiteDomain,
  isInKioskMode,
  saveTokensInLocaleStorage
} from "utils"
import SignInWithPassword from "./SignInWithPassword"
import { setSystemSubdomain, setTokens } from "@redux"
import { initApi } from "services/api"
import classes from "./index.module.scss"

const initialFormState = {
  url: "",
  password: "",
  username: "",
  confirmationCode: "",
  tempToken: "",
  subdomain: "",
  domain: ""
}

const SignIn = () => {
  const [t] = useTranslation()

  const dispatch = useDispatch()

  const history = useHistory()

  const location = useLocation()

  const queries = parse(location.search)

  const [form, setForm] = useState(initialFormState)

  const checkUserRole = (accessToken) => {
    const { role } = jwtDecode(accessToken)

    if (role === "access") return true

    toast.error(t("اجازه_دسترسی_به_این_پنل_را_ندارین"))

    history.replace("/")

    return false
  }

  const getDomainAndSubdomain = async () => {
    const json = localStorage.getItem("url")

    const data = JSON.parse(json || "null")

    if (data === null) return

    setForm(prev => ({
      ...prev,
      subdomain: data.subdomain,
      domain: data.domain
    }))
  }

  const redirectToFoodsPage = async () => {
    const accessToken =
      localStorage.getItem("at")

    dispatch(
      setTokens({
        accessToken,
        refreshToken: ""
      })
    )

    const domain = getSiteDomain()

    initApi(domain)

    if (queries.isTopup || queries.isSubscriptionPayment) {
      return history.replace(`/subscription-plans${location.search}`)
    }

    const pathname =
      isInKioskMode() ? "/kiosk-languages" : "/foods"

    history.replace(pathname)
  }

  const autoRedirectUser = () => {
    if (!localStorage.getItem("at"))
      return getDomainAndSubdomain()

    redirectToFoodsPage()
  }

  const autoLogin = async () => {
    if (!checkUserRole(queries.accessToken)) return

    userLogout()

    const domain = getSiteDomain()

    initApi(domain)

    dispatch(
      setSystemSubdomain(domain, queries.clientName)
    )

    saveTokensInLocaleStorage(
      queries.accessToken,
      queries.refreshToken
    )

    history.replace("/foods")
  }

  useLayoutEffect(() => {
    const tokenIsInUrl =
      isJWT(queries.accessToken || "") && queries.clientName

    tokenIsInUrl ? autoLogin() : autoRedirectUser()
  }, [])

  return (
    <div className={classes["contianer"]}>
      <SignInWithPassword
        form={form}
        setForm={setForm}
      />
    </div>
  )
}

export default SignIn